export enum AdditionalFieldTypes {
  MULTIPLE_CHOICE = 'multiple-choice',
  SINGLE_CHOICE = 'single-choice',
  CHECKBOX = 'checkbox',
  SET = 'set',
}
